import { useAuth } from '../context/AuthContext';

/**
 * Returns the active space_id, or null when:
 *  - no space is selected yet (multi-space user hasn't picked one)
 *  - the user is an admin with the virtual __admin__ sentinel
 *
 * Use this as a useEffect dependency so data fetches re-run on space switch
 * and are suppressed until a real space is active.
 */
export function useSpaceId() {
  const { activeSpace } = useAuth();
  return (activeSpace?._isAdmin || activeSpace?._isFinance) ? null : (activeSpace?.spaceId ?? null);
}
